module.exports = __webpack_public_path__ + "05926b2b46fd25c136367a9a4a8a8d98.svg";